__turbopack_context__.v({
  "badge": "GalleryModal360-module-scss-module__C5ZYPq__badge",
  "fade-in": "GalleryModal360-module-scss-module__C5ZYPq__fade-in",
  "figure": "GalleryModal360-module-scss-module__C5ZYPq__figure",
  "gallery": "GalleryModal360-module-scss-module__C5ZYPq__gallery",
  "image": "GalleryModal360-module-scss-module__C5ZYPq__image",
  "imageVisible": "GalleryModal360-module-scss-module__C5ZYPq__imageVisible",
  "no-transform": "GalleryModal360-module-scss-module__C5ZYPq__no-transform",
  "rotate": "GalleryModal360-module-scss-module__C5ZYPq__rotate",
  "slider": "GalleryModal360-module-scss-module__C5ZYPq__slider",
  "sliderValue": "GalleryModal360-module-scss-module__C5ZYPq__sliderValue",
});
